import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  OrderDirection,
  SalesPointFilter,
  SalesPointOrderFields,
  SalesPointsService,
  salesPointGetAddress,
} from '@prodcard/core'
import { Ref, ref, watch } from 'vue'
import VAutocompleteServer from './VAutocompleteServer.vue'
import { TextFieldDensity, createCtx, handleError } from '../helpers'
import { isEqual } from 'lodash'

interface SalesPointForSelect {
  address: string
  id: string
}

interface Props {
  salesPointsService: SalesPointsService
  additionalFilterData?: SalesPointFilter
  modelValue?: string
  label?: string
  loading?: boolean
  disabled?: boolean
  density?: TextFieldDensity
}

const count = 15


export default /*#__PURE__*/_defineComponent({
  __name: 'VSalesPointsSelect',
  props: {
    salesPointsService: {},
    additionalFilterData: {},
    modelValue: {},
    label: { default: 'Торговый объект' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    density: {}
  },
  setup(__props: any) {

const props = __props;



const salesPoints: Ref<SalesPointForSelect[]> = ref([])

const select = ref()
const loadDefaultSalesPoint = ref(false)
const isLoadMoreItems = ref(true)
const from = ref(0)
const total = ref(0)
const updateSalesPointList = (
  paging: { from: number; count: number },
  filter?: { search?: string },
  replace = false,
) => {
  handleError(async () => {
    const response = await props.salesPointsService.findAll(createCtx(), {
      paging,
      filter,
      order: { field: SalesPointOrderFields.CREATED_AT, direction: OrderDirection.DESC },
    })

    const resultList = response.items.map(salesPoint => ({
      address: salesPointGetAddress(salesPoint),
      id: salesPoint.id,
    }))

    if (replace) {
      salesPoints.value = resultList
    } else {
      salesPoints.value.push(...resultList)
    }

    isLoadMoreItems.value = salesPoints.value.length < response.total
    from.value += paging.count
    if (total.value !== response.total) total.value = response.total
  })
}

const updateSearchValue = (val: string) => {
  from.value = 0
  updateSalesPointList({ from: from.value, count: count }, { ...props.additionalFilterData, search: val }, true)
}

const findDefaultSalesPointById = (id: string) => {
  handleError(async () => {
    const salesPoint = await props.salesPointsService.findById(createCtx(), id)
    if (salesPoint) {
      select.value = { address: salesPointGetAddress(salesPoint), id: salesPoint.id }
    }
  }, loadDefaultSalesPoint)
}

watch(
  () => props.modelValue,
  val => {
    if (!val && select.value) {
      select.value = undefined
      from.value = 0
      updateSalesPointList({ from: from.value, count: count }, props.additionalFilterData, true)
      return
    }
    if (select.value || !val) return
    findDefaultSalesPointById(val)
  },
  { immediate: true },
)

watch(
  () => props.additionalFilterData,
  (newVal, oldVal) => {
    if (!isEqual(newVal, oldVal)) {
      from.value = 0
      updateSalesPointList({ from: from.value, count: count }, newVal, true)
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VAutocompleteServer, {
    modelValue: select.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((select).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event?.id)))
    ],
    items: salesPoints.value,
    isLoadMoreItems: isLoadMoreItems.value,
    label: _ctx.label,
    "item-title": "address",
    loading: loadDefaultSalesPoint.value || _ctx.loading,
    disabled: loadDefaultSalesPoint.value || _ctx.disabled,
    density: _ctx.density,
    "onUpdate:searchValue": updateSearchValue,
    onLoadMore: _cache[2] || (_cache[2] = search => updateSalesPointList({ from: from.value, count: count }, { search, ..._ctx.additionalFilterData }))
  }, null, 8, ["modelValue", "items", "isLoadMoreItems", "label", "loading", "disabled", "density"]))
}
}

})